import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '~/styles/index.scss'; // global css

import App from './App.vue';
import shared from './shared';
import global from '~/components/Global';

import router from './router';
import store from './store';
import '~/permission';
import { post } from '~/utils/request';
import Cookies from 'js-cookie';
import moment from 'moment';
import VueWechatTitle from 'vue-wechat-title';

Vue.use(ElementUI);
Vue.use(VueWechatTitle);

Vue.prototype.$Moment = moment;
Vue.prototype.$Shared = shared;
Vue.prototype.$Global = global;
Vue.prototype.$apiBasePath = shared.apiBasePath(),
Vue.prototype.$webSite = shared.webSite();

Vue.prototype.$isLogin = store.getters.token ? true : false;

var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement('script');
  hm.src = 'https://hm.baidu.com/hm.js?bcf6e81299b4c2a4ee1dab97650ed71f';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(hm, s);
})();

const unloadPage = () => {
  var cookieIdKey = 'CookieId';
  var cookieId = shared.getCookieId(cookieIdKey);
  let userId = Cookies.get('UserID');  
  if(!cookieId){
    cookieId = shared.s4() + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + '-' + shared.s4() + shared.s4() + shared.s4();
    shared.createCookie('CookieId', cookieId, 365);
  }

  let roleId = Cookies.get('RoleID');
  var signCode = global.ME_SIGNCODE;
  if(roleId == 2){
    signCode = global.HR_SIGNCODE;
  }
  let data = {
    type: 'close',
    userId: userId ? userId : '0',
    cookieId: cookieId,
    signCode: signCode,
    from: {
      name: router.currentRoute.name || '',
      path: router.currentRoute.path || '',
      fullPath: router.currentRoute.fullPath || ''
    },
    to: {
      name: '关闭',
      path: '',
      fullPath: ''
    }
  };
  logEvent(data);
};

const logEvent = (params) => {
  post('/PageVisit/Add', params).then();
};

new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created() {
    window.addEventListener('beforeunload', unloadPage);
  },
});

